import styled from "@emotion/styled";
import {ReactComponent as airSvg} from "../../../../images/800CallLogs/Resources for Call Logs/TelephoneBlue.svg"

export const TelephoneBlueSvg = styled(airSvg)`
     width: 50.53px;
     height: 49.47px;
`;